import { Paper, Stack } from "@mui/material";
import React, { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { formatNumberBasedOnUser } from "../utils/namesManipulation";
import { cn } from "../utils/styling";

export type DataCardVariant = "info" | "success" | "warning";

type DataCardProps = {
  className?: string;
  kpi?: {
    name?: string;
    unit?: string;
    value?: number | ReactNode;
  };
  variant?: DataCardVariant;
};

export const dataCardVariantStyles = {
  info: "text-lds-foreground-number-initial",
  success: "text-core-plunge-pool-800",
  warning: "text-core-mystic-red-600",
};

export const dataCardUnitClassName = "font-ds-number-regular-md ";

export const DataCard = ({ className, kpi, variant = "info" }: DataCardProps) => {
  return (
    <Paper className={cn("h-full p-4", className)}>
      <Stack className="h-full items-start justify-between" direction="column" spacing={6}>
        <h2 className="capitalize font-ds-body-semibold-lg">{kpi?.name}</h2>
        {typeof kpi?.value === "object" ? (
          <>{kpi?.value}</>
        ) : (
          <p className={cn("font-ds-number-semibold-xl ", dataCardVariantStyles[variant])}>
            {formatNumberBasedOnUser(kpi?.value) + " "}
            <span className={dataCardUnitClassName}>{kpi?.unit}</span>
          </p>
        )}
      </Stack>
    </Paper>
  );
};

export const EmptyDataCard = ({ className }: { className: string }) => {
  const { t } = useTranslation();
  return (
    <Paper className={`${className} h-full p-4`}>
      <span className="font-ds-body-semibold-lg">{t("BuildingProfile.kpis.kpisNotListed")}</span>
    </Paper>
  );
};
